import {
  H_02,
  HERO_DEFAULTS,
  hideH02Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const H02_PLASMIC_PROPS = {
  h02Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].heading,
    description: "Main hero heading (H02 only)",
    hidden: hideH02Props,
  },
  h02Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].description,
    description: "Hero description text (H02 only)",
    hidden: hideH02Props,
  },
  h02PrimaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].primaryButtonText,
    description: "Primary button text (H02 only)",
    hidden: hideH02Props,
  },
  h02PrimaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].primaryButtonUrl,
    description: "Primary button URL (H02 only)",
    hidden: hideH02Props,
  },
  h02SecondaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].secondaryButtonText,
    description: "Secondary button text (H02 only)",
    hidden: hideH02Props,
  },
  h02SecondaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].secondaryButtonUrl,
    description: "Secondary button URL (H02 only)",
    hidden: hideH02Props,
  },
  h02HeroImage: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_02].heroImage,
    description: "Hero image (H02 only)",
    hidden: hideH02Props,
  },
  h02HeroImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_02].heroImageAlt,
    description: "Hero image alt text (H02 only)",
    hidden: hideH02Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
